//Formik
import { useField } from "formik"
import FormikDropDown from "../../../../../helpers/formikInputs/FormikDropDown"
import FormikMultiSelectInput from "../../../../../helpers/formikInputs/FormikMultiSelectInput"
import FormikTextInput from "../../../../../helpers/formikInputs/FormikTextInput"
import { useEffect, useState } from "react"
import elementTypes from "../Elements/elementTypes"
import FormikCalendar from "../../../../../helpers/formikInputs/FormikCalendar"
import {
  getAssessmentDateOnlyFromIso,
  getAssessmentDateOnlyISO,
  getAssessmentTimeOnlyFromIso,
  getAssessmentTimeOnlyISO,
} from "../../helpers/assessmentDateHelper"

export default function ConditionalPropertiesTestInput({
  formikQuestionName,
  sourceQuestion,
  question,
  disabled,
}) {
  const label = "Conditional value test"
  const fieldName = `${formikQuestionName}.conditionalValue`
  const multiFieldName = `${formikQuestionName}.conditionalValueMulti`
  const dateFieldName = `${formikQuestionName}.conditionalValueDate`
  const placeholder = "Please specify test value"
  const isInType = ["IN", "NOT IN"].includes(question?.conditionalType)
  const helpText = `The value to test against the conditional source questions' answer, to be validated to true.${
    isInType ? " Separate list item with a semicolon (;)" : ""
  }`
  const required = question?.conditionalSource
  const disableInput = !question?.conditionalSource || disabled

  const [timeValuesList, setTimeValuesList] = useState([])

  const [valueField, , valueFieldHelpers] = useField(fieldName)
  const [multiValueField, , multiValueHelpers] = useField(multiFieldName)

  useEffect(() => {
    if (isInType) {
      if (
        (valueField.value && !multiValueField.value) ||
        (!valueField.value && multiValueField.value)
      ) {
        let multiValues = valueField.value?.split(";")

        if (sourceQuestion.type === elementTypes.dateElementId && multiValues) {
          multiValues =
            multiValues?.map((value) => getAssessmentDateOnlyFromIso(value)) ||
            []
        }

        if (multiValueHelpers) {
          multiValueHelpers.setValue(multiValues)
        }
      }
    }

    if (
      sourceQuestion?.type === elementTypes.timeElementId &&
      (!timeValuesList || timeValuesList.length === 0)
    ) {
      setTimeValuesList(generateTimeArray())
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sourceQuestion])

  function generateTimeArray() {
    const timeArray = []

    for (let hour = 0; hour < 24; hour++) {
      for (let minute = 0; minute < 60; minute++) {
        const timeString = `1900-01-01T${hour
          .toString()
          .padStart(2, "0")}:${minute.toString().padStart(2, "0")}:00.000Z`

        const dateValue = getAssessmentTimeOnlyFromIso(timeString)

        timeArray.push({ text: dateValue.toFormat("hh:mm a"), id: timeString })
      }
    }

    return timeArray
  }

  if (
    sourceQuestion?.options &&
    sourceQuestion?.options.length > 0 &&
    isInType
  ) {
    return (
      <FormikMultiSelectInput
        label={label}
        name={multiFieldName}
        onChangeCallBack={(value) => {
          if (value && value.length > 0) {
            valueFieldHelpers.setValue(value.join(";"))
          } else {
            valueFieldHelpers.setValue(undefined)
          }
        }}
        options={sourceQuestion.options}
        optionLabel={"text"}
        optionValue={"id"}
        placeholderText={placeholder}
        helpText={helpText}
        required={required}
        disabled={disableInput}
      />
    )
  } else if (sourceQuestion?.options && sourceQuestion?.options.length > 0) {
    return (
      <FormikDropDown
        label={label}
        name={fieldName}
        options={sourceQuestion.options}
        optionLabel={"text"}
        optionValue={"id"}
        placeholderText={placeholder}
        helpText={helpText}
        required={required}
        disabled={disableInput}
      />
    )
  } else if (sourceQuestion?.type === elementTypes.dateElementId) {
    return (
      <FormikCalendar
        label={label}
        name={isInType ? multiFieldName : dateFieldName}
        onChangeCallBack={(value) => {
          if (isInType) {
            const dates = value
              .map((dateValue) => getAssessmentDateOnlyISO(dateValue))
              .join(";")

            valueFieldHelpers.setValue(dates)
          } else {
            valueFieldHelpers.setValue(getAssessmentDateOnlyISO(value))
          }
        }}
        selectionMode={isInType ? "multiple" : undefined}
        placeholderText={placeholder}
        helpText={helpText}
        required={required}
        disabled={disableInput}
      />
    )
  } else if (sourceQuestion?.type === elementTypes.timeElementId) {
    if (isInType && timeValuesList?.length > 0) {
      return (
        <FormikMultiSelectInput
          label={label}
          name={multiFieldName}
          onChangeCallBack={(value) => {
            if (value && value.length > 0) {
              valueFieldHelpers.setValue(value.join(";"))
            } else {
              valueFieldHelpers.setValue(undefined)
            }
          }}
          options={timeValuesList}
          optionLabel={"text"}
          optionValue={"id"}
          placeholderText={placeholder}
          helpText={helpText}
          required={required}
          disabled={disableInput}
        />
      )
    } else {
      return (
        <FormikCalendar
          label={label}
          name={isInType ? multiFieldName : dateFieldName}
          onChangeCallBack={(value) => {
            valueFieldHelpers.setValue(getAssessmentTimeOnlyISO(value))
          }}
          placeholderText={placeholder}
          helpText={helpText}
          required={required}
          disabled={disableInput}
          timeOnly={true}
        />
      )
    }
  } else {
    let keyFilter = undefined

    if (sourceQuestion?.type === elementTypes.numberElementId) {
      if (isInType) {
        keyFilter = /^[0-9.\-;]+$/
      } else {
        keyFilter = /^[0-9.-]+$/
      }
    }

    return (
      <FormikTextInput
        label={label}
        name={fieldName}
        placeholderText={placeholder}
        helpText={helpText}
        required={required}
        disabled={disableInput}
        keyFilter={keyFilter}
      />
    )
  }
}
